import { Link } from 'react-router-dom';
import Icon from '../components/Icons';
import Revelar from '../components/Revelar';
import Acordeao from '../components/Acordeao';
import servicos from '../data/servicos';
import brasilia from '../data/brasilia';
import { site, praca, linkWhatsApp } from '../config';
// Reaproveita trilha, listas e faixa de chamada da página de serviço.
import './ServicoPagina.css';
import './BrasiliaPagina.css';

const mensagem =
  'Olá, preciso de um advogado criminalista em Brasília. Gostaria de falar sobre um caso.';

// Os temas com maior procura local — o hub distribui autoridade para eles.
const destaquesLocais = [
  'prisao-em-flagrante',
  'audiencia-de-custodia',
  'tribunal-do-juri',
  'trafico-de-drogas',
  'violencia-domestica',
  'execucao-penal',
];

export default function BrasiliaPagina() {
  const locais = destaquesLocais
    .map((slug) => servicos.find((servico) => servico.slug === slug))
    .filter(Boolean);

  return (
    <article className="brasilia">
      <header className="servico-topo">
        <div className="container">
          <nav className="trilha" aria-label="Você está em">
            <ol>
              <li>
                <Link to="/">Início</Link>
              </li>
              <li>
                <span aria-current="page">Advogado Criminalista em {site.endereco.cidade}</span>
              </li>
            </ol>
          </nav>

          <div className="servico-topo__grade">
            <div>
              <span className="rotulo">
                <Icon name="local" size={15} /> {praca}
              </span>
              <h1 className="servico-topo__titulo">{brasilia.h1}</h1>

              {brasilia.intro.map((paragrafo) => (
                <p key={paragrafo.slice(0, 40)} className="servico-topo__texto">
                  {paragrafo}
                </p>
              ))}

              <div className="servico-topo__acoes">
                <a
                  className="btn btn--ouro"
                  href={linkWhatsApp(mensagem)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="whatsapp" size={18} />
                  Falar com o advogado
                </a>
                <a className="btn btn--contorno" href={`tel:${site.telefoneLink}`}>
                  <Icon name="telefone" size={18} />
                  {site.telefone}
                </a>
              </div>
            </div>

            <aside className="servico-topo__cartao">
              <span className="servico-topo__icone" aria-hidden="true">
                <Icon name="urgencia" size={28} />
              </span>
              <h2>Atendimento no DF</h2>
              <ul>
                <li>
                  <Icon name="check" size={16} />
                  <span>Presencial com hora marcada</span>
                </li>
                <li>
                  <Icon name="check" size={16} />
                  <span>Deslocamento a delegacias e fóruns do DF</span>
                </li>
                <li>
                  <Icon name="check" size={16} />
                  <span>{site.plantao}</span>
                </li>
                <li>
                  <Icon name="check" size={16} />
                  <span>{site.horario}</span>
                </li>
              </ul>
              <p className="servico-topo__legal">
                Não há recepção aberta para atendimento sem agendamento prévio. O
                local da reunião é combinado no momento do agendamento.
              </p>
            </aside>
          </div>
        </div>
      </header>

      {/* ---------- estrutura judiciária local ---------- */}
      <section className="secao secao--escura">
        <div className="container">
          <div className="cabecalho-secao">
            <span className="rotulo">Justiça criminal do DF</span>
            <h2 className="titulo-secao">Como as coisas funcionam aqui</h2>
            <p className="subtitulo-secao">
              O Distrito Federal tem uma organização judiciária própria. Saber
              qual delegacia registrou a ocorrência e qual vara recebeu o caso é
              o que define a primeira providência.
            </p>
          </div>

          <ul className="estrutura">
            {brasilia.estrutura.map((item, indice) => (
              <Revelar as="li" key={item.titulo} atraso={(indice % 3) * 90}>
                <h3>{item.titulo}</h3>
                <p>{item.texto}</p>
              </Revelar>
            ))}
          </ul>
        </div>
      </section>

      {/* ---------- serviços mais procurados no DF ---------- */}
      <section className="secao">
        <div className="container">
          <div className="cabecalho-secao">
            <span className="rotulo">Demandas mais frequentes</span>
            <h2 className="titulo-secao">Casos atendidos no Distrito Federal</h2>
          </div>

          <ul className="servico-relacionados">
            {locais.map((servico) => (
              <li key={servico.id}>
                <Link to={`/${servico.slug}`}>
                  <Icon name={servico.icone} size={22} />
                  <span>
                    <strong>{servico.titulo}</strong>
                    <span>{servico.resumo}</span>
                  </span>
                  <Icon name="seta" size={18} className="servico-relacionados__seta" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ---------- perguntas ---------- */}
      <section className="secao secao--escura">
        <div className="container servico-faq">
          <div className="cabecalho-secao cabecalho-secao--centro">
            <span className="rotulo">Dúvidas Frequentes</span>
            <h2 className="titulo-secao">Sobre o atendimento em {site.endereco.cidade}</h2>
          </div>
          <Acordeao itens={brasilia.faq} idBase="brasilia" />
        </div>
      </section>

      <section className="servico-chamada">
        <div className="container servico-chamada__interno">
          <div>
            <h2>Precisa de um criminalista no DF hoje?</h2>
            <p>
              O primeiro contato é sigiloso e não gera compromisso. Em caso de
              prisão em flagrante, ligue antes de qualquer depoimento.
            </p>
          </div>
          <a
            className="btn btn--claro"
            href={linkWhatsApp(mensagem)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="whatsapp" size={18} />
            Falar agora
          </a>
        </div>
      </section>
    </article>
  );
}
